import { ApiFetchType } from '@/server/api-fetch';

export type InterestRatesType = {
    sparkonto_privat: string | null;
    fastrantekonto_privat: string | null;
    sparkonto_foretag: string | null;
    sparkonto_trygg: string | null;
    fastrantekonto_foretag: string | null;
    sparkonto_foretagarna: string | null;
};

export type GeneralSettingsApiResponse = {
    humany_settings: {
        humany_base_url: string | null;
        humany_client_id: string | null;
        humany_page_link: string | null;
        humany_page_link_business: string | null;
        humany_ai_chatbot_widget_name: string | null;
        humany_enable_search_results: boolean | null;
        humany_global_chatbot_enable: boolean | null;
        humany_global_chatbot_text: string | null;
        humany_search_api: string | null;
        humany_search_api_business?: string | null;
        humany_enable_search_results_business?: boolean | null;
        humany_use_cached?: boolean | null;
    };
    zendesk_settings?: {
        zendesk_chatbot_activate: boolean;
        zendesk_chatbot_apikey: string;
        zendesk_chatbot_language_field_id?: string;
        zendesk_source_field_id?: string;
    };
    mfn_single_page_link: string | null;
    mfn_landing_page_link?: string | null;
    consumerloan_version: string;
    external_modules_version: string;
    cookie_read_more_page: string | null;
    show_floating_cookie: boolean | null;
    schema_fields?: {
        phone: string;
        email: string;
        street_address: string;
        locality: string;
        post_code: string;
        address_country?: string;
        founding_date: string;
        social_links: {
            url: string;
        }[];
    } | null;
    interest_rates: InterestRatesType | null;
    trustpilot_settings?: {
        trustpilot_enabled: boolean;
        trustpilot_show_in_footer: boolean;
        trustpilot_businessunit_id: string;
        trustpilot_review_url: string;
        trustpilot_locale?: string;
    } | null;
    legislative_council_referral?: {
        header: string;
        text: string;
    } | null;
};

export const GENERAL_SETTINGS_QUERY_KEY = 'general-settings';

export const getGeneralSettings = (context: ApiFetchType) =>
    context.fetch ? context.fetch<GeneralSettingsApiResponse>('api/general/general') : null;
